import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withdrawFundsIcon from "../../../../assets/img/withdraw-funds.svg";
import { withdrawFunds } from "../../withdraw-funds";
import { translate as t } from "../../../../infrastructure/translate/localization";

import "./balance-sections.scss";

class WithdrawFunds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destinationAccount: "",
    };
  }

  render() {
    const { destinationAccount } = this.state;
    return (
      <div className="balance-hidden-content balanceSection">
        <div className="cob-btn-group">
          <div className="thumbnail">
            <img src={withdrawFundsIcon} alt="generate alert" />
          </div>
          <div>
            <p className="title-balance-section">
              {t("my-account-section.withdrawn-funds")}
            </p>
            <p>{t("my-account-section.request-withdrawn-funds")}</p>
          </div>
        </div>

        <div className="cob-btn-group right-group">
          <div className="cob-input-group iban">
            <label className="input-label">
              {t("my-account-section.iban-destination")}
            </label>
            <div>
              <input
                className="with-icon"
                placeholder="IBAN"
                value={destinationAccount}
                onChange={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^\dA-Za-z]/g, "")
                    .replace(/(.{4})/g, "$1 ")
                    .trim()
                    .toUpperCase();
                  this.setState({ destinationAccount: e.target.value });
                }}
              />
              <FontAwesomeIcon icon="pen" alt="edit" />
            </div>
          </div>

          <button
            type="button"
            className="cob-btn btn-primary not-uppercase"
            disabled={destinationAccount.length === 0}
            onClick={() => withdrawFunds(destinationAccount)}
          >
            {t("actions.withdraw")}
          </button>
        </div>
      </div>
    );
  }
}

export default WithdrawFunds;
